import React from 'react'

import { employersPaySchedules } from 'rails_routes'
import { Banner, Button } from 'slab'
import { useWindowLocation } from 'utils/windowLocation'

interface UnassignedEmployeesHeaderBannerProps {
  /** Whether to show the CTA button */
  showCta?: boolean
}

export const UnassignedEmployeesHeaderBanner: React.FC<UnassignedEmployeesHeaderBannerProps> = ({
  showCta = false
}) => {
  const { assign } = useWindowLocation()

  return (
    <Banner
      type='warning'
      title='Some employees are not assigned to a pay schedule'
      cta={showCta
        ? (
          <Button
            variant='secondary'
            size='small'
            onClick={() => { assign(employersPaySchedules.index()) }}
          >
            Assign employees
          </Button>
          )
        : undefined}
    >
      You must assign all invited employees to a pay schedule in Thatch so we can correctly calculate and time their deductions with each paycheck.
      <br />
      Until you've assigned these employees, we'll keep using the default monthly schedule for their deductions.
    </Banner>
  )
}
